import { formatCurrency } from "helpers/formatCurrency";
import React from "react";
import { calculateDonationTotal } from "widgets/Donation/utils/donationCalculatorHelpers";
import { frequencyLabel } from "widgets/Donation/utils/regularGivingHelpers";

import TextTranslator from "components/TranslateText/TextTranslator";
import "./_style.scss";
import CurrencyChip from "components/CurrencyChip/CurrencyChip";

export const DonationTotalWrapper = ({
  data,
  handlers,
  values,
  perk,
  regularGiving,
  overrides = {},
}) => {
  const { feeStructure } = data;
  const currency = overrides.currency || feeStructure.currency;
  const currencySymbol = overrides.currencySymbol || feeStructure.currencySymbol;
  const regularGivingContext = {
    ...data, values, perk, regularGiving,
  };
  const donationTotal = calculateDonationTotal(feeStructure, { values });
  const hasFrequencyLabel = frequencyLabel(false, true, regularGivingContext);
  const openCurrencyModal = handlers.openCurrencyModal
    ? handlers.openCurrencyModal()
    : null;
  const totalText = "Total amount:total:";

  return (
    <div className="donation-form__line-item --total donation-total__container">
      <span>
        <span
          className="donation-form__line-item-label --total-label donation-total__change-currency"
          data-testid="donation-total-amount-currency"
        >
          <TextTranslator
            replacements={{ total: frequencyLabel(false, true, regularGivingContext) ?? "" }}
            children={totalText}
          />
        </span>

        {openCurrencyModal !== null && (
          <span className="donation-form__line-item-label --change-currency donation-form__currency-conversion">
            <a
              className="donation-form__line-item--currency-change"
              onClick={openCurrencyModal}
              data-testid="donation-change-currency"
            >
              <TextTranslator>Change currency</TextTranslator>
            </a>
          </span>
        )}
      </span>
      <span className="donation-form__line-item-value" data-testid="donation-form-total">
        <div className="value-container">
          <CurrencyChip
            currency={currency?.toUpperCase()}
            size="large"
            hasMargin
          />

          <span className="donation-form__line-item-total">
            {
              formatCurrency(donationTotal, { currencySymbol })
            }
          </span>
        </div>

        {
            hasFrequencyLabel.length > 0
            && (
            <span className="donation-form__line-item-suffix">
              {
                frequencyLabel(true, true, regularGivingContext)
              }
            </span>
            )
          }
      </span>
    </div>
  );
};

export const createDonationTotal = (data, i, formProps, handlers, overrides = {}) => (
  <DonationTotalWrapper
    key={i}
    label="Donation Total"
    name="donationTotal"
    data={data}
    handlers={handlers}
    values={formProps.values}
    perk={formProps.values.perksCart}
    regularGiving={data.regularGiving}
    overrides={overrides}
  />
);
